import { Link, useNavigate } from "react-router-dom"
import Pagination from "../../Components/Pagination"
import SearchField from "../../Components/Forms/SearchField";

export default function DernieresReservation({data}){

    const navigate = useNavigate();
    

    const tableItems = [
        {
            avatar: "https://images.unsplash.com/photo-1511485977113-f34c92461ad9?ixlib=rb-1.2.1&q=80&fm=jpg&crop=faces&fit=crop&h=200&w=200&ixid=eyJhcHBfaWQiOjE3Nzg0fQ",
            id: "RSV-TYTF-HUHGF-POR",
            date: "10 Janv 2023",
            proprio : 'Jean Mabiala',
            status: "Reservée"
        },
        {
            avatar: "https://randomuser.me/api/portraits/men/86.jpg",
            id: "RSV-TYTF-HUHGF-POR",
            position: "10 Mars 2023",
            proprio : 'Jean Mabiala',
            status: "Reservée"
        },
        {
            avatar: "https://randomuser.me/api/portraits/women/79.jpg",
            id: "RSV-TYTF-HUHGF-POR",
            date: "10 Janv 2023",
            proprio : 'Jean Mabiala',
            status: "Reservée"
        },
        {
            avatar: "https://api.uifaces.co/our-content/donated/xZ4wg2Xj.jpg",
            id: "RSV-TYTF-HUHGF-POR",
            date: "10 Janv 2023",
            proprio : 'Jean Mabiala',
            status: "Reservée"
        },
        {
            avatar: "https://images.unsplash.com/photo-1439911767590-c724b615299d?ixlib=rb-1.2.1&q=80&fm=jpg&crop=faces&fit=crop&h=200&w=200&ixid=eyJhcHBfaWQiOjE3Nzg0fQ",
            id: "RSV-TYTF-HUHGF-POR",
            date: "10 Janv 2023",
            proprio : 'Jean Mabiala',
            status: "Reservée"
        },
        {
            avatar: "https://images.unsplash.com/photo-1439911767590-c724b615299d?ixlib=rb-1.2.1&q=80&fm=jpg&crop=faces&fit=crop&h=200&w=200&ixid=eyJhcHBfaWQiOjE3Nzg0fQ",
            id: "RSV-TYTF-HUHGF-POR",
            date: "10 Janv 2023",
            proprio : 'Jean Mabiala',
            status: "Reservée"
        },
        {
            avatar: "https://images.unsplash.com/photo-1439911767590-c724b615299d?ixlib=rb-1.2.1&q=80&fm=jpg&crop=faces&fit=crop&h=200&w=200&ixid=eyJhcHBfaWQiOjE3Nzg0fQ",
            id: "RSV-TYTF-HUHGF-POR",
            date: "10 Janv 2023",
            proprio : 'Jean Mabiala',
            status: "Reservée"
        },
        {
            avatar: "https://images.unsplash.com/photo-1439911767590-c724b615299d?ixlib=rb-1.2.1&q=80&fm=jpg&crop=faces&fit=crop&h=200&w=200&ixid=eyJhcHBfaWQiOjE3Nzg0fQ",
            id: "RSV-TYTF-HUHGF-POR",
            date: "10 Janv 2023",
            proprio : 'Jean Mabiala',
            status:"Reservée"
        },
        {
            avatar: "https://images.unsplash.com/photo-1439911767590-c724b615299d?ixlib=rb-1.2.1&q=80&fm=jpg&crop=faces&fit=crop&h=200&w=200&ixid=eyJhcHBfaWQiOjE3Nzg0fQ",
            id: "RSV-TYTF-HUHGF-POR",
            date: "10 Janv 2023",
            proprio : 'Jean Mabiala',
            status: "Reservée"
        },
        {
            avatar: "https://images.unsplash.com/photo-1439911767590-c724b615299d?ixlib=rb-1.2.1&q=80&fm=jpg&crop=faces&fit=crop&h=200&w=200&ixid=eyJhcHBfaWQiOjE3Nzg0fQ",
            id: "RSV-TYTF-HUHGF-POR",
            date: "10 Janv 2023",
            proprio : 'Jean Mabiala',
            status: "Reservée"
        },
       
    ]

    return (
        <div className="">
            <p className="text-xl font-bold text-gray-800 sm:text-2xl dark:text-gray-200">Dernieres reservations</p>
    
            <div className="mt-12 overflow-x-auto rounded-lg shadow-sm">
                <table className="w-full text-sm text-left table-auto">
                    <thead className="font-medium text-gray-600 bg-gray-200 border-b border-gray-600 dark:text-gray-200 dark:bg-gray-800">
                        <tr>
                            <th className="px-6 py-3">Id</th>
                            <th className="px-6 py-3">Clients</th>
                            <th className="px-6 py-3">Date</th>
                            <th className="px-6 py-3">status</th>
                            <th className="px-6 py-3">Annonce</th>
                        </tr>
                    </thead>
                    <tbody className="text-gray-600 divide-y">
                        {
                            data.map((item, idx) => (
                                
                                    <tr key={idx} className="w-full text-left transition bg-gray-200 border-gray-600 rounded cursor-pointer hover:bg-gray-200 duration-900 dark:text-gray-200 hover:text-gray-800 dark:bg-gray-800"
                                        onClick={()=>navigate(`/reservation/details/${item.id}`)}
                                    >
                                        
                                            <td className="flex items-center px-6 py-3 gap-x-3 whitespace-nowrap">
                                                <div>
                                                    <span className="block text-sm font-medium">{item.id}</span>
                                                </div>
                                            </td>
                                            
                                            <td className="px-6 py-4 whitespace-nowrap">{item.client.firstname}</td>
                                            
                                            <td className="px-6 py-4 whitespace-nowrap">{new Date(item.createdAt).toLocaleDateString()}</td>
                                            {item.status === 2 && <span className={`px-3 py-2 rounded-full font-semibold text-xs text-green-600 bg-green-600 bg-opacity-15`}>
                                            {'Confirmée'}
                                            </span>}

                                            {item.status === 0 && <span className={`px-3 py-2 rounded-full font-semibold text-xs text-gray-600 bg-gray-600 bg-opacity-15`}>
                                            {'En attente'}
                                            </span>}

                                            {item.status === 1 && <span className={`px-3 py-2 rounded-full font-semibold text-xs text-purple-600 bg-purple-600 bg-opacity-15`}>
                                            {'Approuvée'}
                                            </span>}

                                            {item.status === -1 && <span className={`px-3 py-2 rounded-full font-semibold text-xs text-red-600 bg-red-600 bg-opacity-15`}>
                                            {'Annulée'}
                                            </span>}

                                            {item.status === -2 && <span className={`px-3 py-2 rounded-full font-semibold text-xs text-red-600 bg-red-600 bg-opacity-15`}>
                                            {'Refusée'}
                                            </span>}
                                            <td className="px-6 py-4 whitespace-nowrap">{item.annonce.title}</td>


                                            
                                    </tr>
                                
                            ))
                        }
                    </tbody>
                </table>
            </div>
        </div>
    )
}